export const isPrimitive = (data: any): data is string | number | boolean => {
  return ['string', 'number', 'boolean'].includes(typeof data);
};

/**
 * Useful when there's a checkbox in UI and API value is `boolean | null | undefined`
 * Simply mapping a checkbox value to API value may override `null` value with `false`
 * that actually was not changed by the user
 */
type BoolToApiValueArgs<API_VALUE extends boolean | null | undefined> = {
  apiValue: API_VALUE;
  formValue: boolean;
};
export const boolToApiValue = <API_VALUE extends boolean | null | undefined>({
  apiValue,
  formValue,
}: BoolToApiValueArgs<API_VALUE>): API_VALUE => {
  if (formValue) {
    return true as API_VALUE;
  }
  if (!apiValue) {
    return apiValue;
  }
  return false as API_VALUE;
};

/**
 * Useful when there's a checkbox in UI and API value is `number | null | undefined`
 * Simply mapping a checkbox value to API value may override `null` value with 0
 * that actually was not changed by the user
 */
type NumToApiValueArgs<API_VALUE extends number | null | undefined> = {
  apiValue: API_VALUE;
  formValue: number;
};
export const numToApiValue = <API_VALUE extends number | null | undefined>({
  apiValue,
  formValue,
}: NumToApiValueArgs<API_VALUE>): API_VALUE => {
  if (formValue) {
    return formValue as API_VALUE;
  }
  if (!apiValue) {
    return apiValue;
  }
  return 0 as API_VALUE;
};

/**
 * Verifies that value is a valid enum value
 * @param enumObject - enum
 * @param value - a string to verify
 */
export const isValidEnumValue = <T extends Record<string, string | number>>(
  enumObject: T,
  value: unknown
): value is T[keyof T] => {
  return Object.values(enumObject).includes(value as T[keyof T]);
};
